//Entra Auth configuration
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const isProduction = window.location.hostname === 'dashboard.degarmo.com';

const authSettings = isProduction
  ? {
      clientId: '61c49f1c-d73a-48d3-95f4-cd9013ea9a40',
      authority: 'https://dgcustomers.ciamlogin.com/dgcustomers.onmicrosoft.com',
      redirectUri: 'https://dashboard.degarmo.com/auth-callback',
      postLogoutRedirectUri: 'https://dashboard.degarmo.com/account/login',
      knownAuthorities: ['dgcustomers.ciamlogin.com'],
    }
  : {
      clientId: 'cc41e9e2-2f51-45be-af87-ebe531552849',
      authority: 'https://dgstagingcustomers.ciamlogin.com/',
      redirectUri: 'https://dashboard.dgstaging.com/auth-callback',
      postLogoutRedirectUri: 'https://dashboard.dgstaging.com/account/login',
      knownAuthorities: ['dgstagingcustomers.ciamlogin.com'],
    };

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    ...authSettings,
    OIDCOptions: {
      defaultScopes: [],
    },
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    // If you set this to "true", you must also set the cacheLocation to "localStorage" or "sessionStorage"
  },
  /*system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },*/
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};
